import { gql } from '@apollo/client';

export default gql`
  query timetableBannerNews($market: MarketEnum!) {
    timetableBannerNews(market: $market) {
      id
      severity
      category
      title {
        ...translations
      }
      description {
        ...translations
      }
      commercial {
        ...translations
      }
      dateStart
      dateEnd
      dateEffectStart
      dateEffectEnd
      dateUpdate
    }
  }

  fragment translations on TimetableTranslations {
    en
    fr
    de
    nl
  }
`;
